import { render, staticRenderFns } from "./batch-manage.vue?vue&type=template&id=3d54faf0&scoped=true&"
import script from "./batch-manage.vue?vue&type=script&lang=js&"
export * from "./batch-manage.vue?vue&type=script&lang=js&"
import style0 from "./batch-manage.vue?vue&type=style&index=0&id=3d54faf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54faf0",
  null
  
)

export default component.exports